import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { isPlatformServer, NgClass } from '@angular/common';
import { ApiService } from '../../../../services/api.service';
import { ToasterService } from '../../../../services/toaster.service';
import {
  NgxOtpInputComponent,
  NgxOtpInputComponentOptions,
} from 'ngx-otp-input';
import { Router } from '@angular/router';
import { routes } from '../../../../constants/routes';
import { UtilityService } from '../../../../services/utility.service';

@Component({
  selector: 'app-verify-email-otp',
  standalone: true,
  imports: [TranslateModule, NgClass, NgxOtpInputComponent],
  templateUrl: './verify-email-otp.component.html',
  styleUrl: './verify-email-otp.component.scss',
})
export class VerifyEmailOtpComponent {
  otpValue: string = '';

  private time: any;
  private timeLeft: any;
  private display: any;

  isTimerOn = false;
  resendTimeRemaining: number = 120;
  resendTimer: any;
  resendEnabled: boolean = false;

  readonly otpLength = 6;

  isOtpFilled: boolean = false;

  otpInputConfig: NgxOtpInputComponentOptions = {
    otpLength: 6,
    autoFocus: true,
  };

  email: string = '';

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toaster: ToasterService,
    private utilService: UtilityService,
    @Inject(PLATFORM_ID) public platformId: string,
  ) {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras.state;
    this.email = state?.['email'] || '';
    if (!this.email) this.editEmail();
  }

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    window.clearInterval(this.timeLeft);
    this.startResendTimer(this.resendTimeRemaining);
  }

  onVerifyOTP() {
    this.confirmOTP();
  }

  editEmail() {
    this.router.navigate([
      '/',
      routes.account,
      routes.user,
      routes.verifyEmail,
    ]);
  }

  confirmOTP() {
    const email = this.email;
    const otp = +this.otpValue;
    this.apiService
      .verifyEmail(email, otp)
      .pipe()
      .subscribe({
        next: (res) => {
          if (!res?.url) {
            this.router.navigate(
              ['/', routes.account, routes.user, routes.userIdentitySetup],
              {
                state: {
                  email: this.email,
                  isEmailVerifiable: false,
                  authKey: res,
                },
              },
            );
            return;
          }
          this.utilService.openExternalPage(res.url);
        },
        error: (error) => {
          this.toaster.error(error.message);
        },
      });
  }

  cancel() {
    this.otpValue = '';
    if (isPlatformServer(this.platformId)) {
      return;
    }
    window.clearInterval(this.time);
    window.clearInterval(this.timeLeft);
  }

  public startResendTimer(duration: any) {
    var timer = duration,
      minutes,
      seconds;
    this.timeLeft = setInterval(() => {
      minutes = Math.floor(timer / 60);
      seconds = timer % 60;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;
      this.display = minutes + ':' + seconds;
      const timeElement = document.getElementById('timeLeft');
      if (timeElement) {
        timeElement.innerHTML = this.display;
      }
      if (--timer <= 0) {
        this.resendEnabled = true;
        if (isPlatformServer(this.platformId)) {
          return;
        }
        window.clearInterval(this.timeLeft);
      }
    }, 1000);
  }

  handleFillEvent(event: any) {
    this.otpValue = event;
  }

  onResendOTP(event: any) {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    window.clearInterval(this.timeLeft);
    this.resendEnabled = false;
    this.startResendTimer(this.resendTimeRemaining);
    this.reSendOtp();
  }

  reSendOtp() {
    if (this.email) {
      const email = this.email;
      this.apiService
        .sendOtpToEmail(email)
        .pipe()
        .subscribe({
          next: (res) => {
            this.toaster.success(res.message);
          },
          error: (error) => {
            this.toaster.error(error.message);
          },
        });
    }
  }

  handleOtpChange(otp: any) {
    this.isOtpFilled =
      this.utilService.countFilledPlaces(otp) === this.otpInputConfig.otpLength;
  }

  ngOnDestroy() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    window.clearInterval(this.time);
    window.clearInterval(this.timeLeft);
    window.clearInterval(this.resendTimer);
  }
}
